import React from 'react';
interface Logo {
  name: string;
  image: string;
}
interface OrbitalLogosProps {
  logos: Logo[];
  radius?: number;
}
const OrbitalLogos: React.FC<OrbitalLogosProps> = ({
  logos,
  radius = 120
}) => {
  return <div className="relative w-full h-[400px] flex items-center justify-center" data-id="element-232">
      <div className="absolute w-64 h-64 rounded-full bg-gradient-to-br from-primary-500/20 to-secondary-500/20 backdrop-blur-xl animate-blob" data-id="element-233" />
      <div className="relative w-24 h-24 rounded-full bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center shadow-2xl z-10" data-id="element-234">
        <span className="text-white font-bold text-lg" data-id="element-235">合作伙伴</span>
      </div>
      {logos.slice(0, 8).map((logo, index) => {
      const angle = index * 360 / 8;
      const delay = index * 2.5;
      return <div key={index} className="absolute w-20 h-20 rounded-full bg-white shadow-lg flex items-center justify-center animate-orbital" style={{
        animationDelay: `${delay}s`,
        animationDuration: '20s'
      }} data-id="element-236">
            <span className="text-xs font-semibold text-gray-700 text-center px-2" data-id="element-237">
              {logo.name}
            </span>
          </div>;
    })}
    </div>;
};
export default OrbitalLogos;